import { NgModule } from '@angular/core';

import { TaFormlyCheckboxModule } from './ta-checkbox/ta-checkbox.module';
import { TaFormlyFieldWrapperModule } from './ta-field-wrapper/ta-field-wrapper.module';
import { TaFormlyHiddenModule } from './ta-hidden/ta-hidden.module';
import { TaFormlyInputModule } from './ta-input/ta-input.module';
import { TaFormlyInstructionModule } from './ta-instruction/ta-instruction.module';
import { TaFormlyRadioModule } from './ta-radio/ta-radio.module';
import { TaFormlyRangeModule } from './ta-range/ta-range.module';
import { TaFormlyStepperModule } from './ta-stepper/ta-stepper.module';
import { TaFormlyTextareaModule } from './ta-textarea/ta-textarea.module';
import { TaFormlyToggleModule } from './ta-toggle/ta-toggle.module';

@NgModule({
    imports: [
        TaFormlyCheckboxModule,
        TaFormlyFieldWrapperModule,
        TaFormlyHiddenModule,
        TaFormlyInputModule,
        TaFormlyInstructionModule,
        TaFormlyRadioModule,
        TaFormlyRangeModule,
        TaFormlyStepperModule,
        TaFormlyTextareaModule,
        TaFormlyToggleModule
    ],
    exports: [TaFormlyFieldWrapperModule],
})
export class TaFormlyModule { }
